import z from "zod";

export const batchUpdateSchema = z.object({
	batchIds: z.array(z.uuid()).optional(),
});

export function withBatchUpdateSchema<T>(
	schema: z.ZodSchema<T>,
): z.ZodSchema<WithBatchUpdateSchema<T>> {
	return schema.and(batchUpdateSchema);
}

export type WithBatchUpdateSchema<T> = T & z.infer<typeof batchUpdateSchema>;
